import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/%E7%94%B5%E5%BD%B1" },
  { label: "电视剧", to: "/category/%E7%94%B5%E8%A7%86%E5%89%A7" },
  { label: "短片", to: "/category/%E7%9F%AD%E7%89%87" },
];

const helpLinks = [
  { label: "关于我们", to: "/about" },
  { label: "搜索影视", to: "/search" },
  { label: "用户反馈", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 border-t-2 border-primary-500/50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-leaf-fill text-2xl"></i>
              </span>
              <span className="text-2xl font-heading text-background-50">嫩草视频</span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200 max-w-md">
              嫩草视频是一个专注于高清影视内容展示与推荐的平台，汇聚最新电影、热门电视剧与精彩短片，
              用清晰的分类与贴心的推荐，帮助每一位观众快速找到心仪的作品。
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-background-50 font-heading text-lg mb-4">
              <a href="/" className="hover:text-primary-400 transition-colors">
                热门分类
              </a>
            </h4>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-secondary-200 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Help links */}
          <div>
            <h4 className="text-background-50 font-heading text-lg mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors">
                帮助与支持
              </a>
            </h4>
            <ul className="flex flex-col gap-3">
              {helpLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-secondary-200 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs md:text-sm text-secondary-300">
            © 2026 嫩草视频 · 高清影视内容平台. 本站为演示项目，视频内容均为示例，不提供真实播放服务。
          </p>
          <div className="flex items-center gap-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-900 text-secondary-200">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-900 text-secondary-200">
              <i className="ri-live-line text-lg"></i>
            </span>
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-900 text-secondary-200">
              <i className="ri-music-2-line text-lg"></i>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}